import { RedirectButton } from "../components/RedirectButton";

export const NotFound = () => (
  <div>
    <h1>404 - Pagina non trovata!</h1>
    
    <RedirectButton path="/" />
  
  </div>
);